import { React, useState } from 'react';
import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
// import Main from 'layouts/Main';
import Main from 'views/layouts/Main/Main';
import SimContainer from 'components/SimContainer';
import { SimTypography } from 'components/SimTypography';

import { QuickQueryForm, Services, Banner, Questions, ContactDetails } from './components';


const Contact = () => {
	const [checked, setChecked] = useState(true);

	const handleChange = event => {
		setChecked(event.target.checked);
	};

	return (
		<Main bgcolor={'background.default'}>
			{/* START OF CONTACT PAGE */}

			<Banner />

			<Box bgcolor={'alternate.main'} paddingX={'10vw'} addingBottom={'10vh'}>
				{/* SECTION TITLE START */}
				<Box
					marginBottom={4}
					width={1}
					height={1}
					display={'flex'}
					flexDirection={'column'}
					alignItems={'center'}
					alignContent={'center'}
					boxShadow={0}>
					<SimTypography
						sx={{
							textTransform: 'uppercase',
							fontWeight: 'medium'
						}}
						gutterBottom
						color={'secondary'}
						align={'center'}
						marginTop={12}>
						NEXT STEPS
					</SimTypography>

					<SimTypography
						variant='h4'
						align={'center'}
						data-aos={'fade-up'}
						gutterBottom
						sx={{
							fontWeight: 700
						}}>
						We are ready to help in your child’s journey.
					</SimTypography>
					<SimTypography
						variant='h4'
						align={'center'}
						data-aos={'fade-up'}
						gutterBottom
						sx={{
							fontWeight: 700
						}}>
						What about you?
					</SimTypography>

					<Box display='flex' flexDirection='row'>
						<SimTypography paddingTop={3} alignItems={'centre'}>
							{' '}
							I'm not sure yet.
						</SimTypography>
						<Box paddingTop={2} alignItems={'flex-start'}>
							<Switch
								checked={checked}
								onChange={handleChange}
								inputProps={{ 'aria-label': 'controlled' }}
							/>
						</Box>
						<SimTypography paddingTop={3} alignItems={'centre'}>
							{' '}
							I am ready, let's start.
						</SimTypography>
					</Box>
				</Box>
				{checked ? (
					<Questions />
				) : (
					<SimContainer>
						<QuickQueryForm />
					</SimContainer>
				)}
			</Box>

			<Box bgcolor={'alternate.main'}>
				<SimContainer paddingX={6}>
					<Services />
				</SimContainer>
			</Box>

			<Box bgcolor={'#252626'} /* paddingLeft={2} */>
				<ContactDetails />
			</Box>

			{/*END OF CONTACT PAGE */}
		</Main>
	);
};

export default Contact;


// import { React, useState, useEffect } from 'react';
// import { Box, Switch, Alert } from '@mui/material';

// import Main from 'views/layouts/Main/Main';
// import SimContainer from 'components/SimContainer';
// import { SimTypography } from 'components/SimTypography';

// import { QuickQueryForm, Services, Banner, Questions, ContactDetails } from './components';
// import { vi } from 'date-fns/locale';

// const Contact = () => {
//     const [checked, setChecked] = useState(true);

//     // --> 2. Add state for the alert and use useEffect to set it on load
//     const [alert, setAlert] = useState({ message: '', severity: 'info' });

//     useEffect(() => {
//         // This code runs once when the component first loads
//         setAlert({
//             message: 'my code',
//             severity: 'info' // 'info' is good for debugging messages
//         });
//     }, []); // The empty array [] ensures this runs only once

//     const handleChange = event => {
//         setChecked(event.target.checked);
//     };

//     return (
//         <Main bgcolor={'background.default'}>
//             {/* START OF CONTACT PAGE */}

//             {/* --> 3. Add the Alert component here to display the message */}
//             <SimContainer>
//                 {alert.message && (
//                     <Alert severity={alert.severity} sx={{ mt: 2, mb: 2 }}>
//                         {alert.message}
//                     </Alert>
//                 )}
//             </SimContainer>

//             <Banner />

//             {/* ... The rest of your existing JSX ... */}
//             <Box bgcolor={'alternate.main'} paddingX={'10vw'} paddingBottom={'10vh'}>
//                 {/* SECTION TITLE START */}
//                 <Box
//                     marginBottom={4}
//                     width={1}
//                     height={1}
//                     display={'flex'}
//                     flexDirection={'column'}
//                     alignItems={'center'}
//                     alignContent={'center'}
//                     boxShadow={0}>
//                     <SimTypography
//                         sx={{
//                             textTransform: 'uppercase',
//                             fontWeight: 'medium'
//                         }}
//                         gutterBottom
//                         color={'secondary'}
//                         align={'center'}
//                         marginTop={12}>
//                         NEXT STEPS
//                     </SimTypography>

//                     <SimTypography
//                         variant='h4'
//                         align={'center'}
//                         data-aos={'fade-up'}
//                         gutterBottom
//                         sx={{
//                             fontWeight: 700
//                         }}>
//                         We are ready to help in your child’s journey.
//                     </SimTypography>
//                     <SimTypography
//                         variant='h4'
//                         align={'center'}
//                         data-aos={'fade-up'}
//                         gutterBottom
//                         sx={{
//                             fontWeight: 700
//                         }}>
//                         What about you?
//                     </SimTypography>

//                     <Box display='flex' flexDirection='row'>
//                         <SimTypography paddingTop={3} alignItems={'centre'}>
//                             {' '}
//                             I'm not sure yet.
//                         </SimTypography>
//                         <Box paddingTop={2} alignItems={'flex-start'}>
//                             <Switch
//                                 checked={checked}
//                                 onChange={handleChange}
//                                 inputProps={{ 'aria-label': 'controlled' }}
//                             />
//                         </Box>
//                         <SimTypography paddingTop={3} alignItems={'centre'}>
//                             {' '}
//                             I am ready, let's start.
//                         </SimTypography>
//                     </Box>
//                 </Box>
//                 {checked ? (
//                     <Questions />
//                 ) : (
//                     <SimContainer>
//                         <QuickQueryForm />
//                     </SimContainer>
//                 )}
//             </Box>

//             <Box bgcolor={'alternate.main'}>
//                 <SimContainer paddingX={6}>
//                     <Services />
//                 </SimContainer>
//             </Box>

//             <Box bgcolor={'#252626'} /* paddingLeft={2} */>
//                 <ContactDetails />
//             </Box>

//             {/*END OF CONTACT PAGE */}
//         </Main>
//     );
// };

// export default Contact;